import React from 'react';
import Avatar from 'react-avatar'
import Image from 'react-bootstrap/Image'
import Uppy from '@uppy/core'
import AwsS3 from '@uppy/aws-s3'
import { DragDrop } from '@uppy/react'
import * as moment from 'moment-timezone'
import '@uppy/core/dist/style.css'
import '@uppy/drag-drop/dist/style.css'
import './formStyle.scss'


{/* <FormImageUploader
    fullSize
    imageUrl={toEdit?.imageUrl}
    name="imageUrl"
    label="Preview Image"
    // defaultName={user.instructorProfile?.pageName}
    filePath={`users/${partnerId}/files/`}
    sublabel={"Anyone can see this image, recommended aspect ratio 16:9"}
    register={register}
    onChange={(imageUrl) => setValue('imageUrl', imageUrl)}
    imageUrl={getValues("imageUrl")}
    error={errors.imageUrl}
    // getValues={getValues}
    // fileSelection={(file) => setValue('imageUrl', file)}
/> */}

function ImageAndUpload(props) {
    const {rectangle, square} = props

    // "266px", height: "150px"
    var height = 150
    if (square) {
        height = 266
    } else if (rectangle) {
        height = 150
    }


    const { imageUrl, filePath, name, onChange } = props

    const [imagePreviewUrl, setImagePreviewUrl] = React.useState(
        imageUrl ? imageUrl : null
    )

    const uppy = React.useMemo(() => {
        return Uppy({
                autoProceed: true,
                id: "FormImageUploader",
                restrictions: {
                    maxNumberOfFiles: 1,
                    allowedFileTypes: [".jpg", ".jpeg", ".png"]
                }
            })
            .use(AwsS3, {
                    limit: 1,
                    timeout: 1000 * 60 * 60,
                    getUploadParameters(file) {
                        console.log("getupload parms: ", file)
                    // Send a request to our signing endpoint.
                        return fetch(process.env.REACT_APP_API_BASE_URL + '/storage/getSignedUrl', {
                                method: 'post',
                                // Send and receive JSON.
                                headers: {
                                    accept: 'application/json',
                                    'content-type': 'application/json',
                                },
                                body: JSON.stringify({
                                    filename: (filePath ?? "files/") + moment().unix() + file.name,
                                    contentType: file.type,
                                }),
                            })
                            .then(response => {
                                // console.log("signedUrl: ", response.json())
                                return response.json()
                            });
                    },
            })
            .on('upload-success', (result) => {
                console.log("Upload success: ", result)
                const storagePath = result?.meta?.storagePath
                const type = result?.meta?.type
                if (!storagePath || !type) { return }
                fetch(process.env.REACT_APP_API_BASE_URL + '/storage/getDownloadUrl', {
                    method: 'post',
                    headers: {
                        accept: 'application/json',
                        'content-type': 'application/json',
                    },
                    body: JSON.stringify({
                        filename: storagePath,
                        contentType: type,
                    }),
                }).then(response => {
                    return response.json()
                }).then(json => {
                    console.log("downloadurl: ", json)
                    if (json?.onDemand?.downloadUrl) {
                        setImagePreviewUrl(json.onDemand.downloadUrl)
                        onChange(json.onDemand.downloadUrl)
                    }
                })
            })
    }, [])

    return (
        <div className={`d-flex d-row align-items-center`}>
            <div style={{width: "266px", height: `${height}px`, position: "relative"}} className="mr-3">
                <div
                style={{width: "266px", height: `${height}px`, position: "absolute"}} className="mr-3">
                    <Image thumbnail src={imagePreviewUrl} style={{objectFit: 'cover', width: '100%', height: '100%'}} />
                </div>
                <div className={imagePreviewUrl ? "dragDropFilled" : ""}>
                    <DragDrop
                        allowMultipleFiles={false}
                        height={height}
                        width={266}
                        style={{position: "absolute"}}
                        uppy={uppy}
                        locale={{
                            strings: {
                                // Text to show on the droppable area.
                                // `%{browse}` is replaced with a link that opens the system file selection dialog.
                                dropHereOr: 'Drop here or %{browse}',
                                // Used as the label for the link that opens the system file selection dialog.
                                browse: 'browse'
                            }
                        }}
                    />
                </div>
            </div>
            <button 
            onClick={() => {
                uppy.reset()
                setImagePreviewUrl(null)
                onChange(null)
            }}
            type="button" className="btn btn-primary">
                Remove Image
            </button>
        </div>
    )
}

export { ImageAndUpload }

function FormImageUploader({ error, type, label, sublabel, register, defaultName, ...otherProps}) {

    const invalidStyle = {width: "100%", marginTop: "0.25rem", fontSize: "80%", color: "#ff4136"}

    const {onChange} = otherProps

    const {fullSize} = otherProps;
    var leftCol = fullSize ? "col-md-3" : "col-md-2"
    var rightCol = fullSize ? "col-md-9" : "col-md-6"

    return (
    <div className="form-group row">
        {label && (<label className={`${leftCol} col-form-label`}>
            <h6>{label}</h6>
            {sublabel && (<small>{sublabel}</small>)}
        </label>)}

        <div className={`${rightCol} d-flex align-items-center`}>
            <ImageAndUpload rectangle {...otherProps} />
            {error && (
                <div style={invalidStyle}>
                    {error.message}
                </div>
            )}
        </div>
        

    </div>
    );
}

export default FormImageUploader
